import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const UmbrellaIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 19C18 20.6569 16.6569 22 15 22C13.3431 22 12 20.6569 12 19V12M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12H22Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

UmbrellaIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(UmbrellaIcon);
